<template>
  <div>
    <b-card title="País">
      <!-- <b-link
        size="sm"
        class="btn-sm btn-nav-link btn-nav-link-white lk-help"
        :to="{ name: 'admin-layout-register' }"
      >
        Adicionar
      </b-link> -->
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="true"
        :hasUpdateDataButton="true"
        :totalRows="totalRows"
        :limit="limit"
        @updateData="loadData"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import layoutService from "@/providers/layoutService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from '@/providers/dropdownService';
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "isDesktop", label: "Dispositivo", type: "boolean", sortable: false },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: false },
        { field: "email", label: "Email", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por email', trigger: 'enter' }},
        { field: "origin", label: "Origem", sortable: false, type: "object", object_field: "name" },
        { field: "_id", label: "ID", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por código', trigger: 'enter' } },
        // { field: "dt_update", label: "Atualização", type: "custom_date", sortable: false },
      ],
      languages: []
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Layout Wdma Hist');
    // this.loadDataFilter();
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append('page', this.page);
      params.append('limit', this.limit);
      
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      dropdownService.getAllLanguage(new URLSearchParams())
      .then(res => {
        const language = res.map(item => {
          return { value: item.id, text: item.name };
        });
        this.fields[this.fields.findIndex(item => item.field=='language')].filterOptions.filterDropdownItems = language;
        this.setInitialTableFilters();
      })
      .catch(err => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_LAYOUT_WDMA_HIST_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      layoutService
        .deleteLayoutWdmaHist(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', layoutService.getAllLayoutWdmaHist(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>